import {
  TestBuy,
  TestBuyProductWithCriteria,
} from "@coworker/types/lib/testbuy";
import { partitionArticlesByStatus } from "../../CommonComponents/article.helpers";
import { LostPassedSalesWidget } from "../../CommonComponents/LostPassedSalesWidget";
import ArticlesHeader from "./ArticlesHeader";
import { WidgetDivider } from "@coworker/reusable/components/Widgets";
import { TestbuyItemsListView } from "@coworker/apprestructured/src/testbuy/components/TestbuyItemsListView/TestbuyItemsListView";

interface HistoricDetailsProps {
  testbuy: TestBuy;
  testbuyItems: TestBuyProductWithCriteria[];
}

export function HistoricDetails({
  testbuyItems,
  testbuy,
}: HistoricDetailsProps) {
  const { SUCCESS, FAIL } = partitionArticlesByStatus(testbuyItems);
  const currency = [...SUCCESS, ...FAIL][0]?.currency || "";

  return (
    <>
      <LostPassedSalesWidget
        isSingleTestbuy
        currency={currency}
        lostSales={FAIL.reduce((acc, curr) => acc + curr.price, 0)}
        passedSales={SUCCESS.reduce((acc, curr) => acc + curr.price, 0)}
      />
      <WidgetDivider />
      <ArticlesHeader count={FAIL.length} type="FAIL" />
      <TestbuyItemsListView
        isCompletedTestbuy
        testbuy={testbuy}
        filteredTestbuyItems={FAIL}
      />
      <WidgetDivider />
      <ArticlesHeader count={SUCCESS.length} type="SUCCESS" />
      <TestbuyItemsListView
        isCompletedTestbuy
        testbuy={testbuy}
        filteredTestbuyItems={SUCCESS}
      />
    </>
  );
}
